import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=user
  useEffect(() => {
    const token = localStorage.getItem("elite_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("elite_token"); setUser(false); });
  }, []);

  const login = async (email, password, portal = "mortgage") => {
    try {
      const { data } = await api.post("/auth/login", { email, password, portal });
      localStorage.setItem("elite_token", data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      if (data.token) {
        localStorage.setItem("elite_token", data.token);
        setUser(data.user);
        return { ok: true, user: data.user };
      }
      return { ok: true, pending: true, message: data.message };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const forgotPassword = async (email, portal = "mortgage") => {
    try {
      const { data } = await api.post("/auth/forgot-password", { email, origin_url: window.location.origin, portal });
      return { ok: true, message: data.message };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const resetPassword = async (token, password) => {
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      return { ok: true, message: data.message };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("elite_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, forgotPassword, resetPassword, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
